import React from 'react'
import Toggle from '../../utils/Animations/Toggle'
import AdvisorDetail from './AdvisorDetail'
import AdvisorProfile from './AdvisorProfile'
import { BaseAdvisorProfileProps } from '../../utils/types'
import { trackEvent } from '../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../context/MatchScreenContext'
import '../../styles/Advisors/AdvisorsShared.scss'
import '../../styles/Advisors/DirectAdvisor.scss'
import '../../styles/Animations/Toggle.scss'
import ExternalLinkIcon from '../../utils/Icons/ExternalLinkIcon'
import useFacetRevisitLink from '../../hooks/useFacetRevisitLink'

function BaseAdvisorProfile ({ advisor, details, position }: BaseAdvisorProfileProps) {
  const isHumanAdvisor = advisor.format === 'human'
  const { state: { pageKey } } = useMatchScreen()

  const toggleAdvisorDetailsCallback = () => {
    trackEvent('MatchScreen', 'show-more-details', {
      page_key: pageKey,
      'advisor-details': advisor.name,
      Position: position
    })
  }

  const filteredDetails = details?.filter(detail => detail && detail.value)

  const profileDetailsClass = `profile_details ${isHumanAdvisor ? 'profile_details--direct' : 'profile_details--shared'}`
  const detailsTopRowClass = `details_top_row ${isHumanAdvisor ? 'details_top_row--direct' : 'details_top_row--shared'}`
  const detailsStatClass = `details_stat ${isHumanAdvisor ? 'details_stat--direct' : 'details_stat--shared'}`
  const prefilledDisclosure = useFacetRevisitLink(advisor.disclosure)

  return (
        <AdvisorProfile advisor={advisor}>
            <Toggle openTitle='Hide Details' closeTitle='Show Details' openCallback={toggleAdvisorDetailsCallback}>
                <div className={profileDetailsClass}>
                    <div className={detailsTopRowClass}>
                        {filteredDetails?.map((detail, index) => (
                            <AdvisorDetail
                                key={index}
                                title={detail.title}
                                value={detail.value}
                                link={detail.link}
                                isEmail={detail.isEmail}
                                isPhone={detail.isPhone}
                                isExternal={detail.isExternal}
                                hasIcon={detail.hasIcon}
                                className={detailsStatClass}
                                advisor={advisor}
                                position={position}
                            />
                        ))}
                    </div>
                    {(prefilledDisclosure || (!isHumanAdvisor && advisor.firmCrd)) && (
                        <div className="details_bottom_row">
                            <Toggle openTitle='Disclosure' closeTitle='Disclosure' className="disclosureToggle" iconVariant="disclosure">
                                {prefilledDisclosure && (<div dangerouslySetInnerHTML={{ __html: prefilledDisclosure }} />)}
                                {!isHumanAdvisor && advisor.firmCrd && (
                                    <span className="disclosureBrochure">
                                        <a href={`https://adviserinfo.sec.gov/firm/brochure/${advisor.firmCrd}`} target="_blank" rel="noopener noreferrer">
                                          View Firm Disclosure Brochure <ExternalLinkIcon />
                                        </a>
                                    </span>
                                )}
                            </Toggle>
                        </div>
                    )}
                </div>
            </Toggle>
        </AdvisorProfile>
  )
}

export default BaseAdvisorProfile
